import { createBuriedTracker } from '~/utils/buried';

export default defineNuxtPlugin(() => {
  if (import.meta.server) {
    useHead({
      script: [
        {
          innerHTML: `
(function(w, d, s, q) {w[q] =w[q] || []; var f=d.getElementsByTagName(s)[0],j=d.createElement(s); j.async=true; j.id='beacon-aplus'; j.src='https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.cjs.js'; f.parentNode.insertBefore(j, f);})(window, document, 'script', 'aplus_queue');
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['appKey', 'yp9o0yljena9pdpgzqums8t1']  });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['trackDomain', 'https://quickaplus-he-api-cn-shanghai.aliyuncs.com']  });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-heatmap-enabled', true] });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-autotrack-enabled', false] });
          `,
        },
      ],
    });
    return;
  }

  // 根据环境配置埋点
  const buriedConfig = {
    autoTrack: true,
    enableClick: true,
    enableExposure: true,
    enableScroll: true,
    exposureThreshold: 0.5,
    scrollThrottle: 200,
    customEvents: {},
  };

  // 创建并初始化埋点实例
  const tracker = createBuriedTracker(buriedConfig);
  tracker.init();

  // 提供埋点实例给应用使用
  return {
    provide: {
      buriedTracker: tracker,
    },
  };
});
